import React from 'react'
import styled from 'styled-components'
import Task from './task'
import { Droppable } from '../../shared-componenets/AtlasDragDrop/Droppable'

const Container = styled.div`
  margin: 8px;
  border: 1px solid lightgrey;
  border-radius: 2px;
  width: 50%;

  display: flex;
  flex-direction: column;
`
const Title = styled.h3`
  padding: 8px;
`
const TaskList = styled.div`
  padding: 8px;
  transition: background-color 0.2s ease;
  background-color: ${props =>
        props.isDraggingOver ? 'silver' : 'white'}
  flex-grow: 1;
  min-height: 100px;
`

export default class Column extends React.Component {
  render() {
    return (
      <Container>
        <Title>{this.props.column.title}</Title>
        <Droppable droppableId={String(this.props.column.id)} type="TASK" className="committee-droparea">
          {({ isDraggingOver }) => (
            <TaskList isDraggingOver={isDraggingOver}>
              {this.props.tasks.map((task, index) => (
                <Task key={`${task.id}`} task={task} index={index} />
              ))}
            </TaskList>
          )}
        </Droppable>
      </Container>
    );
  }
}
